import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClimateCareComponent } from '../../clients/climatecare/climatecare.component';

const routes: Routes = [
  {
    path: '',
    component: ClimateCareComponent
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

